import React from "react";
import { Button, HStack } from "@chakra-ui/react";
import { PaginationDot } from "./PaginationDot";

interface WizardFooterProps {
  onCancel: () => void;
  onNext: () => void;
  canGoNext: boolean;
  goToStep: (step: number) => void;
  activeStep: number;
  stepCount: number;
  nextButtonText?: string;
  cancelButtonText?: string;
}

export const WizardFooter = ({
  onCancel,
  onNext,
  activeStep,
  canGoNext,
  goToStep,
  stepCount,
  nextButtonText = "Next",
  cancelButtonText = "Cancel",
}: WizardFooterProps) => (
  <HStack justifyContent="space-between" mt={4}>
    <Button size={"lg"} variant="secondary" onClick={onCancel}>
      {cancelButtonText}
    </Button>
    <HStack spacing={3}>
      {Array.from({ length: stepCount }).map((_, index) => (
        <PaginationDot
          key={index}
          isActive={activeStep === index}
          onClick={() => goToStep(index)}
          disabled={index > activeStep}
          index={index}
        />
      ))}
    </HStack>
    <Button
      size={"lg"}
      disabled={!canGoNext}
      variant="primary"
      onClick={onNext}
    >
      {nextButtonText}
    </Button>
  </HStack>
);
